// Assignment Methods
export const ASSIGNMENT_METHOD_AUTOMATIC = 'Automatic Text Classifier';
export const ASSIGNMENT_METHOD_DEFAULT = 'Default';
export const ASSIGNMENT_METHOD_FORWARDED = 'Forwarded';
export const ASSIGNMENT_METHOD_MANUAL = 'Manually Assigned';
export const ASSIGNMENT_METHOD_SUGGESTED = 'Suggested Text Classifier';
